import ReturnsTable from './ReturnsTable';
import { withI18n } from 'react-i18next';

export default withI18n()(ReturnsTable);
